define(function (require) {
    const ViewManager = require('civicsUtils/view_manager');
	const selectedFavoriteTemplate = require('civicsViews/favoriteContacts/add_favorite_modal/t_cpv_add_favorites_modal.hbs');
	const selectedFavoriteItemView = require('civicsViews/favoriteContacts/add_favorite_modal/v_itv_add_favorites_modal');
	const mainController = require('civicsViews/favoriteContacts/controllers/main_controller');
	const Utils = require('civicsUtils/general_utilities');

	return Marionette.CompositeView.extend({
		className: 'selected-favorites-container-modal',
		template: selectedFavoriteTemplate,
		childView: selectedFavoriteItemView,
		childViewContainer: '.selected-favorite-items',
		childEvents: {
			'selected-item:remove': 'onRemoveInvitationItem',

		},
		ui: {
            addFavoriteButton: '.add-favorite-button',
            cancelButton: '.cancel-button',
			closeModalButton: '.bbm-btn-close'

		},
		events: {
			'click @ui.addFavoriteButton': 'addFavorites',
			'click @ui.cancelButton': 'cancelClicked',
			'click @ui.closeModalButton':'closeModal',


		},
		initialize: function (options) {
			this.config = options.config ? options.config : {};
			this.isPortalInstrument = this.config.dataForReview ? true : false;
            this.controller = new mainController(this.config);
			this.collection = options.collection;
			this.modalRegion = options.modalRegion;
            this.additionalCapacityTypes = options.additionalCapacityTypes;
            this.applicantTypes = options.applicantTypes;
			this.isInviteProcess = options.isInviteProcess;
			this.submitApplCollection = options.submitApplCollection;
			this.listenTo(this.collection, 'change:removeFromSelected', this.onRemoveSelectedItem);
		},
		childViewOptions:function(model, index){
			return {
				config: this.config,
                additionalCapacityTypes: this.additionalCapacityTypes,
                applicantTypes: this.applicantTypes,
				isInviteProcess: this.isInviteProcess
    
			}
		},
        addFavorites: function(){
			ViewManager.resetErrorMessages(this);
			let tempApplicantData = [];
			tempApplicantData  = this.controller.processContactsForSubmission(this.children, this.isPortalInstrument, this.isInviteProcess, this.config)


			if(this.isInviteProcess){
				this.sendInvites(tempApplicantData);
			}else{
				this.addAsApplicant(tempApplicantData);
			}

        },
		addAsApplicant : function(data){
			let applicantData = data;
			let isBulkUpdate = applicantData.length > 1 ? true: false;
			if(this.isPortalInstrument){ //means instrument record is being created in add instrument portlet
				const uniqueApplicants = this.controller.getValidApplicants(applicantData, this.submitApplCollection, this.config, this.children, this.isPortalInstrument);
				if (uniqueApplicants.length !== applicantData.length) {
					// All were duplicates — no need to call API
					return;
				}

				this.triggerMethod('call-contact:added', data);
			}else{
			const uniqueApplicants = this.controller.getValidApplicants(applicantData, this.config.addApplEditCollection, this.config, this.children);
			if (uniqueApplicants.length !== applicantData.length) {
				// All were duplicates — no need to call API
				return;
			}
				this.addAsApplicantPromise = this.controller.addFavoritesAsApplicants(applicantData);
				this.addAsApplicantPromise.done(() => {
					this.modalRegion.hideModal();
					if(isBulkUpdate){
						Utils.civicsToastPop( i18n.t('CIVICS.COMMON_ADD_APPLICANT.BULK_ADDITIONAL_APPLICANT_UPDATED_SUCCESS'), "success");
					}else{
						Utils.civicsToastPop( i18n.t('CIVICS.COMMON_ADD_APPLICANT.SINGLE_ADDITIONAL_APPLICANT_UPDATED_SUCCESS'), "success");
					}
					window.location.reload();
				}).fail((response)=>{
					ViewManager.errorToWindow(response);
				});			
				
			}
		},
		sendInvites : function(data){
			let favoriteData = data;
			let isBulkUpdate = favoriteData.length > 1 ? true : false
			if(this.isPortalInstrument){ //means instrument record is being created in add instrument portlet
				const uniqueApplicants = this.controller.getValidInvites(favoriteData, this.config.submitInvitationsList, this.config, this.children, this.isPortalInstrument);
				if (uniqueApplicants.length !== favoriteData.length) {
					// All were duplicates — no need to call API
					return;
				}

				this.triggerMethod('call-invite:added', favoriteData);
				this.modalRegion.hideModal();
			}else{
				const uniqueApplicants = this.controller.getValidApplicants(favoriteData, this.config.addApplEditCollection, this.config, this.children,);
				if (uniqueApplicants.length !== favoriteData.length) {
					// All were duplicates — no need to call API
					return;
				}

				this.sendInvitesToFavoritesPromise = this.controller.sendInvitesToFavorites(favoriteData);
				this.sendInvitesToFavoritesPromise.done(() => {
					this.modalRegion.hideModal();
					if(isBulkUpdate){
						Utils.civicsToastPop( i18n.t('CIVICS.COMMON_INVITE_APPLICANT.BULK_INVITE_APPLICANT_UPDATED_SUCCESS'), "success");
					}else{
						Utils.civicsToastPop( i18n.t('CIVICS.COMMON_INVITE_APPLICANT.SINGLE_INVITE_APPLICANT_UPDATED_SUCCESS'), "success");
					}
					window.location.reload();
				}).fail((response)=>{
					ViewManager.errorToWindow(response);
				});	
			}

		},
		onShow: function () {
		},
		onRender: function(){
			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();
			ViewManager.resetErrorMessages(this);
		},
        cancelClicked: function () {
			this.triggerMethod('showCancel', !!this.config.countRecancel);
			this.config.countRecancel = 1;
		},
		onRemoveSelectedItem: function (childView) {
			if(this.collection.length == 1){
				this.cancelClicked(); //if there's only one in the list, just show the cancel dialog instead of having an empty grid
			}else {
				this.collection.remove(childView);
			}


		},
        closeModal:function(){
			if (this.modalRegion) {
			  this.modalRegion.hideModal();
			}
		  },
		templateHelpers: function() {
			return {
				config: this.config,
                requireCapacity: this.config.requireCapacity,
				showCapacity: (this.config.showCapacity && this.additionalCapacityTypes && this.additionalCapacityTypes.length > 1) ? true : false,
				showApplicantType: function() {
					if (this.config.instrumentType.toLowerCase() == "tradelicense") {
						return false;
					}

					return this.config.showApplicantType;
                },
				titleText:this.isInviteProcess ? i18n.t('CIVICS.FAVORITES.DIALOG.INVITE_SELECTED_CONTACTS') :  i18n.t('CIVICS.FAVORITES.DIALOG.ADD_SELECTED_CONTACTS'),
				nextButtonText: this.isInviteProcess ? i18n.t('CIVICS.FAVORITES.DIALOG.SEND') :  i18n.t('CIVICS.FAVORITES.DIALOG.ADD'),
				selectedCount: this.collection ? this.collection.length : 0 
			};
		},
	});
});
